module.exports = __webpack_public_path__ + "img/workout-notebook_B095GLS213.3921db68.jpg";